// Related products

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer?.observe(productRecommendationsSection);

  // Recently Viewed Products

  document.addEventListener("DOMContentLoaded", function () {
    const recentlyViewedElement = document.querySelector(".recently-viewed-products");
    if (!recentlyViewedElement) return;

    const productHandle = recentlyViewedElement.dataset.productHandle;
    const productLimit = 4; 

    function addToRecentlyViewed() {
        if (typeof Storage !== "undefined") {
            let viewedProducts = JSON.parse(localStorage.getItem("viewedProducts")) || [];

            const existingIndex = viewedProducts.indexOf(productHandle);
            if (existingIndex !== -1) {
                viewedProducts.splice(existingIndex, 1);
            }

            viewedProducts.unshift(productHandle);

            if (viewedProducts.length > productLimit) {
                viewedProducts.pop();
            }

            localStorage.setItem("viewedProducts", JSON.stringify(viewedProducts));

        } else {
            console.error("Local storage is not supported.");
        }
    }

    addToRecentlyViewed();

    async function fetchRecentlyViewedProducts() {
      let viewedProducts = JSON.parse(localStorage.getItem("viewedProducts")) || [];
    
      viewedProducts = viewedProducts.filter(handle => handle !== productHandle).slice(0, productLimit);
  
      if (viewedProducts.length === 0) {
          document.querySelector(".product-recommendations-grid.recently-viewed-products").style.display = "none";
          return;
      }
  
      let html = "";
      
      const productPromises = viewedProducts.map(handle => {
          const query = `
              query {
                  productByHandle(handle: "${handle}") {
                      id
                      title
                      handle
                      vendor
                      priceRange {
                          minVariantPrice {
                              amount
                              currencyCode
                          }
                      }
                      featuredImage {
                          url
                      }
                      images(first: 2) {
                          edges {
                              node {
                                  url
                              }
                          }
                      }
                      metafield(namespace: "custom_fields", key: "image_for_collection_page") {
                          value
                      }
                  }
              }
          `;
          
          return fetch(window.Shopify.routes.root + "api/2024-01/graphql.json", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "X-Shopify-Storefront-Access-Token": "31fc1e66b1130108980f23142c4eaab4"
              },
              body: JSON.stringify({ query })
          }).then(response => response.json());
      });
  
      try {
          const productResponses = await Promise.all(productPromises);
  
          productResponses.forEach(response => {
              if (response.errors) {
                  console.error("GraphQL Error:", response.errors);
                  return;
              }
  
              const product = response.data.productByHandle;
              if (!product) return;
  
              const metafieldImage = product.metafield ? product.metafield.value : product.featuredImage?.url;
              
              html += `
                  <div class="parentItemProductSearch itemSearchGrid product-card ng-scope store-grid-item">
                        <a class="linkCollectionParent" href="/products/${product.handle}">
                            <div class="parentImageItemCollection">
                                <img src="${metafieldImage}" class="img_ItemCollection image-first">
                                <img src="${product.featuredImage.url}" class="ss-image-alt ng-scope">
                            </div>
                            <div class="innerContentItemCol">
                                <p class="titleItemCollection">
                                    ${product.title}
                                </p>
                                <p class="designerNameParent">
                                    ${product.vendor}
                                </p>
                                <p class="priceParent">
                                    ${formatPrice(product.priceRange.minVariantPrice.amount, product.priceRange.minVariantPrice.currencyCode)}
                                </p>
                                <!-- Quick View Trigger -->
                                <button class="js__quick--view ss-quick-view ng-scope" data-id="${product.id}" data-handle="${product.handle}">
                                    Quick View
                                </button>
                            </div>
                        </a>
                    </div>
              `;
          });
  
          document.querySelector('.recently-viewed-container').innerHTML = html;
      } catch (error) {
          console.error("Error fetching recently viewed products:", error);
      }
  }
  

    fetchRecentlyViewedProducts();

    function formatPrice(amount, currency) {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amount);
    }
});
